export const mockRiesgoMedio = {
    error: false,
    data: {
        quoteId: "0Q0dq0000004sMnCAI",
        ApplicationId: 4000412,
        ExamData: "<ExamDetails xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' Title='Object Mapping' Language='es-CO' MatchKeyId='0000' ErrorGeneratingQA='false' TimeTakenToAnswer=''><Questions><Question Id='ae55c04d-239d-4713-878d-49708513d5c6' QuestionId='46' Text='¿Usted fue beneficiario del fondo de reserva (FRECH) para la adquisición de vivienda que otorgó el Gobierno?' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>SI</Answer><Answer IsSelected='false' CorrectAnswer='false'>NO</Answer></Question><Question Id='7002b0de-f66d-4f6d-8859-a5868a4b6292' QuestionId='110' Text='¿Actualmente cuántos créditos tiene con CONFIAR?' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>NINGUNO</Answer><Answer IsSelected='false' CorrectAnswer='false'>UNO</Answer><Answer IsSelected='false' CorrectAnswer='false'>DOS</Answer><Answer IsSelected='false' CorrectAnswer='false'>TRES o MÁS</Answer></Question><Question Id='59354643-6fdb-4aa1-8cd9-cfeba135eb1a' QuestionId='13' Text='¿Con qué entidad usted tiene tarjeta de crédito marca VISA?' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'> BANCO FALABELLA</Answer><Answer IsSelected='false' CorrectAnswer='false'>CORFES</Answer><Answer IsSelected='false' CorrectAnswer='false'>INVERSORA PICHINCHA S.A.</Answer><Answer IsSelected='false' CorrectAnswer='false'>NINGUNA DE LAS ANTERIORES</Answer></Question><Question Id='784195d5-8933-4a38-a9bc-7956c61d26e6' QuestionId='10' Text='¿Con qué entidad usted adquirió una cuenta corriente en los últimos seis meses?' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>DATASCORING DE COLOMBIA SOCIEDAD ANONIMA</Answer><Answer IsSelected='false' CorrectAnswer='false'>CREDIBANCO- VISA</Answer><Answer IsSelected='false' CorrectAnswer='false'>THE ROYAL BANK OF SCOTLAND COLOMBIA S.A.</Answer><Answer IsSelected='false' CorrectAnswer='false'>Ninguna de las anteriores</Answer></Question></Questions></ExamDetails>"
    }
}

export const mockRisgomediodos =
{
    data:
    {
        ApplicationId: 4157889,
        ExamData: "<ExamDetails xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' Title='Object Mapping' Language='es-CO' MatchKeyId='0000' ErrorGeneratingQA='false' TimeTakenToAnswer=''><Questions><Question Id='922e1849-1a61-4f63-b67d-d8509ed8decf' QuestionId='105' Text='En su crédito de consumo (TARJETA DE CRÉDITO) con ACT FINAN Y DE SEGUR - QNT SAS, su relación con la obligación es:' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>ESTAR COMO DEUDOR PRINCIPAL DE LA OBLIGACIÃ“N</Answer><Answer IsSelected='false' CorrectAnswer='false'>ESTAR COMO CODEUDOR, FIADOR, DEUDOR SOLIDARIO Ã“ AVALISTA DE LA OBLIGACIÃ“N</Answer><Answer IsSelected='false' CorrectAnswer='false'>No estoy relacionado en ningún crédito de consumo con esta entidad actualmente</Answer></Question><Question Id='5c2e9b45-77d2-47c4-8b72-4064af5fb27f' QuestionId='23' Text='¿Hace cuánto tiempo usted tiene crédito de vehículo con GNB SUDAMERIS?' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>MENOS DE 2 AÃ‘OS</Answer><Answer IsSelected='false' CorrectAnswer='false'>ENTRE 2 Y 4 AÃ‘OS</Answer><Answer IsSelected='false' CorrectAnswer='false'>MÃS DE 4 AÃ‘OS</Answer><Answer IsSelected='false' CorrectAnswer='false'>No tengo crédito de vehículo con la entidad</Answer></Question><Question Id='04e1e14c-03e4-46f9-be36-840499fb3749' QuestionId='29' Text='En los últimos seis meses, ¿con cuál de las siguientes entidades usted tenía una tarjeta de crédito y un crédito de vivienda?' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>AV VILLAS</Answer><Answer IsSelected='false' CorrectAnswer='false'>COLPATRIA</Answer><Answer IsSelected='false' CorrectAnswer='false'>BNC S.A. - FIDUBNC S.A.</Answer><Answer IsSelected='false' CorrectAnswer='false'>Ninguna de las anteriores</Answer></Question><Question Id='43bba84e-b737-4e30-9840-695d59fb3d27' QuestionId='104' Text='En su crédito de vivienda con LEASING  CORFICOLOMBIANA S.A., su relación con la obligación es:' Type='MultipleChoicesSingleAnswer' IsDummy='0' isQuestionTextHasListTypeDataElement='false' ListAnswerIndex='0' ExpirationTime='05:00' TimeTakenToAnswer=''><Answer IsSelected='false' CorrectAnswer='false'>ESTAR COMO DEUDOR PRINCIPAL DE LA OBLIGACIÃ“N</Answer><Answer IsSelected='false' CorrectAnswer='false'>ESTAR COMO CODEUDOR, FIADOR, DEUDOR SOLIDARIO Ã“ AVALISTA DE LA OBLIGACIÃ“N</Answer><Answer IsSelected='false' CorrectAnswer='false'>No estoy relacionado en ningún crédito de vivienda con esta entidad actualmente</Answer></Question></Questions></ExamDetails>",
        quoteId: "0Q0U9000000TvkTKAS"
    },
    error: false
}


// export const mockResponseQuotePhoneList = {

//     ApplicationId: 4022010,
//     quoteId: "0Q0dq0000006najCAA",
//     listPhones: [
//         {
//             isSelect: false,
//             mobilePhoneNumber: "3192314128"
//         },
//         {
//             isSelect: false,
//             mobilePhoneNumber: "3057962404"
//         },
//         {
//             isSelect: false,
//             mobilePhoneNumber: "3105559075"
//         },
//         {
//             isSelect: false,
//             mobilePhoneNumber: "3235889624"
//         },
//         {
//             isSelect: false,
//             mobilePhoneNumber: "No se encuentra su Número"
//         }
//     ],

//     errorCode: "INVOKE-200",
//     error: "false"
// }

export const mockResponseQuotePhoneList = {
    data: {
        listPhones: [
            {
                isSelect: false,
                mobilePhoneNumber: "3106601137"
            },
            {
                isSelect: false,
                mobilePhoneNumber: "3127061925"
            },
            {
                isSelect: false,
                mobilePhoneNumber: "3123311199"
            },
            {
                isSelect: false,
                mobilePhoneNumber: "3172161023"
            },
            {
                isSelect: false,
                mobilePhoneNumber: "No se encuentra su Número"
            }
        ],
        ApplicationId: 4123263,
        quoteId: "0Q0U9000000PcTVKA0",
        errorCode: "INVOKE-200",
        error: "OK"
    },
    error: false
}

export const mockPantallaInquilinoError1 = {
    data: {
        quoteId: "0Q0dq00000021CvCAI",
        message: "Ingresar los parámetros requeridos"
    },
    error: true
}

export const mockPantallaInquilinoError2 = {
    data: {
        quoteId: "0Q0dq00000021CvCAI",
        message: "La cotización no existe 2"
    },
    error: true
}

export const mockPantallaInquilinoError3 = {
    data: {
        ApplicationId: 3940252,
        LeadId: "0R123dq000000463TSF",
        leadRequeriment: "VC02: rechazo de cc inquilino bloqueada por intentos",
        message: "Riesgo Alto"
    },
    error: true
}

export const mockPantallaInquilinoError4 = {
    data: {
        quoteId: "0Q0dq0000004jRaCAI",
        ApplicationId: 3942056,
        LeadId: "0R123dq000000463TSF",
        message: "Verificación fallida por no poseer información",
        LeadRequeriment: "IDV03: No tiene información inquilino "
    },
    error: true
}

export const mockPantallaInquilinoError5 = {
    error: true,
    data: {
        quoteId: "0Q0dq0000004jRaCAI",
        ApplicationId: 3942085,
        message: "Información no coincide",
        LeadRequeriment: "IDV04.05-06-07: Sin coincidencia verificación ID inquilino",
        LeadId: "0R123dq000000463TSF"
    }
}

export const mockPantallaInquilinoError6 = {
    error: true,
    data: {
        quoteId: "0Q0dq0000004jRaCAI",
        ApplicationId: 3942085,
        message: "Validación fallida por superar bloqueos definidos",
        leadRequirement: "KBA04 &05 & 07: Agoto el tiempos e intentos  preguntas inquilino",
        LeadId: "0R123dq000000463TSF"
    }
}

export const mockPantallaInquilinoError7 = {
    error: true,
    data: {
        quoteId: "0Q0dq0000004jRaCAI",
        ApplicationId: 3942085,
        message: "Validación fallida por no tener información suficiente para generar el cuestionario",
        leadRequirement: "KBA06: Sin información para preguntas  inquilino",
        LeadId: "0R123dq000000463TSF"
    }
}

export const mockPantallaInquilinoError8 = {
    error: true,
    data: {
        quoteId: "0Q0dq0000004jRaCAI",
        ApplicationId: 3942085,
        message: "Error 500 del servidor",
        LeadRequeriment: "VC01, IDV01 & IDV02,OTP01, KBA 01 Y KBA02 : error T.U parte inquilino",
        LeadId: "0R123dq000000463TSF"
    }
}

export const mockPantallaInquilinoError9 = {
    data: {
        quoteId: "0Q0dq00000021CvCAI",
        message: "Error Bad Request"
    },
    error: true
}

export const mockPantallaInquilinoError10 = {
    data: {
        quoteId: "0Q0dq00000021CvCAI",
        message: "Error 500 del servidor"
    },
    error: true
}

export const mockPantallaInquilinoError11 = {
    error: true,
    data: {
        message: "Error al actualizar la cotización.",
        quoteId: "0Q0dq0000005UIPCA2"
    }
}

export const mockPantallaInquilinoError12 = {
    error: true,
    data: {
        message: "Error al actualizar el Lead",
        quoteId: "0Q0dq0000005UIPCA2",
        LeadId: "0R123dq000000463TSF",
    }
}
